module.exports = __webpack_public_path__ + "img/5340283.png";